interface TaskProgressBarProps {
  completed: number;
  target: number;
  overdue?: boolean;
  dueSoon?: boolean;
  size?: "sm" | "md";
}

export default function TaskProgressBar({
  completed,
  target,
  overdue = false,
  dueSoon = false,
  size = "md",
}: TaskProgressBarProps) {
  const percent = target > 0 ? Math.min(100, Math.round((completed / target) * 100)) : 0;
  const done = completed >= target && target > 0;

  let gradient = "from-indigo-500 via-violet-500 to-indigo-600";
  if (done) gradient = "from-emerald-400 via-emerald-500 to-teal-600";
  else if (overdue) gradient = "from-red-500 via-rose-500 to-red-600";
  else if (dueSoon) gradient = "from-amber-400 via-orange-500 to-amber-600";

  const h = size === "sm" ? "h-2" : "h-3";

  return (
    <div className="w-full">
      <div className="mb-1.5 flex items-center justify-between text-xs font-bold">
        <span className="text-secondary">
          {completed}
          <span className="font-semibold text-secondary/45"> / </span>
          {target} lead
        </span>
        <span
          className={`tabular-nums ${
            done
              ? "text-emerald-700"
              : overdue
                ? "text-red-700"
                : dueSoon
                  ? "text-amber-700"
                  : "text-indigo-700"
          }`}
        >
          {percent}%
        </span>
      </div>
      <div
        className={`${h} w-full overflow-hidden rounded-full bg-gray-200 ring-1 ring-secondary/15`}
      >
        <div
          className={`${h} min-w-[6px] rounded-full bg-gradient-to-r ${gradient} shadow-sm transition-all duration-700 ease-out`}
          style={{ width: `${Math.max(percent, percent > 0 ? 6 : 0)}%` }}
        />
      </div>
    </div>
  );
}
